import React from 'react'
import AceCodeEditorContainer from '../../../../Components/Miscellaneous/Editors/AceCodeEditor'

export default function AceCodeEditor() {
  return (
    <div className='page-body'>
        <AceCodeEditorContainer/>
    </div>
  )
}
